import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { LivestreamPlayer } from './components/LivestreamPlayer';
import { LivestreamChatOverlay } from './components/LivestreamChatOverlay';

interface Props {
  livestreamId: string;
  chatChannelId?: string | null;
  title?: string | null;
  username?: string | null;
}

export function LivestreamViewerScreen({
  livestreamId,
  chatChannelId,
  title,
  username,
}: Props): React.ReactElement {
  const navigate = useNavigate();

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/download');
    }
  };

  return (
    <div style={styles.container}>
      <button onClick={handleClose} style={styles.closeButton}>
        <X size={28} />
      </button>

      {(title || username) && (
        <div style={styles.headerOverlay}>
          {title && <h1 style={styles.title}>{title}</h1>}
          {username && <p style={styles.username}>@{username}</p>}
        </div>
      )}

      <div style={styles.playerContainer}>
        <LivestreamPlayer livestreamId={livestreamId} />
        <LivestreamChatOverlay chatChannelId={chatChannelId} />
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: 'calc(var(--vh, 1vh) * 100)',
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: '30px',
    left: '20px',
    background: 'rgba(0, 0, 0, 0.6)',
    border: 'none',
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    cursor: 'pointer',
    color: 'white',
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerOverlay: {
    position: 'absolute',
    top: '30px',
    left: '80px',
    right: '20px',
    zIndex: 100,
    pointerEvents: 'none',
  },
  title: {
    color: '#fff',
    fontSize: '18px',
    fontWeight: 600,
    margin: 0,
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.8)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  username: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '14px',
    margin: '4px 0 0 0',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.8)',
  },
  playerContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
};
